import React from 'react';
import { useNavigate } from 'react-router-dom';
import OverviewCardShell, { OverviewTextAction } from './OverviewCardShell';
import IrlRequestProgress from './IrlRequestProgress';
import styles from './StandardOverview.module.css';
import { IRL_OVERVIEW_STATES } from '../../../utils/standardOverviewIrl';

const AttentionBadge = ({ badge }) => {
    if (!badge) return null;
    return (
        <span
            className={`${styles.attentionBadge} ${badge.tone === 'action' ? styles.attentionBadgeAction : styles.attentionBadgeReview}`}>
            {badge.label}
        </span>
    );
};

const IrlHeaderAside = ({ card }) => (
    <div className={styles.irlHeaderAside}>
        {card.headerMeta ? <span className={styles.cardMetaTiny}>{card.headerMeta}</span> : null}
        {card.overdueCount ? <span className={styles.overdueBadge}>{card.overdueCount} overdue</span> : null}
        <AttentionBadge badge={card.badge} />
    </div>
);

const InformationRequestsCard = ({ model }) => {
    const navigate = useNavigate();
    const card = model.irlCard;
    const highlight = card.highlight || (model.highlight === 'irl' ? 'accent' : false);

    const metricClass =
        card.metric?.size === 'lg'
            ? styles.cardMetric
            : card.metric?.size === 'md'
              ? styles.cardMetricMd
              : styles.cardStatus;

    const showProgress = card.state === IRL_OVERVIEW_STATES.ACTIVE_PROGRESS && card.progress;

    return (
        <OverviewCardShell
            title="Information Requests"
            highlight={highlight}
            tall={card.tall}
            headerAside={card.headerMeta || card.overdueCount || card.badge ? <IrlHeaderAside card={card} /> : null}
            footer={
                <OverviewTextAction onClick={() => navigate(card.navigateTo || '/irl')}>{card.actionLabel}</OverviewTextAction>
            }>
            {card.metric ? <p className={metricClass}>{card.metric.text}</p> : null}
            {showProgress ? <IrlRequestProgress progress={card.progress} /> : null}
            {card.lines.map(line => (
                <p
                    key={line.text}
                    className={line.variant === 'small' ? styles.cardDescriptionSmall : styles.cardDescription}>
                    {line.text}
                </p>
            ))}
        </OverviewCardShell>
    );
};

export default InformationRequestsCard;
